import { useMemo } from 'react';
import type { WebhooksHostProps } from 'shared/webhooks';
import { usePartnerData } from '@/providers/PartnerData.provider';

/**
 * Maps the partner's model onto the shared Webhooks' props for Settings → Webhooks, the partner's own
 * webhooks. Mirrors client-dashboard's useWebhooksHostProps.
 */
export default function useWebhooksHostProps(): WebhooksHostProps {
  const {
    response: { loginUsername, isRoleViewOnly },
  } = usePartnerData();

  return useMemo(
    () => ({
      basePath: '/settings/webhooks',
      // The partner portal has no timezone setting, so History keeps UTC, as the account Webhooks tab does.
      viewer: { username: loginUsername, timezone: 'UTC' },
      readOnly: isRoleViewOnly,
      // A partner can only subscribe to Account Status (`/partner/webhook-url` stores no other event).
      events: ['accountonboarding'],
      // `/partner/webhooks` returns no notification status or response code/text.
      hasDeliveryDetails: false,
    }),
    [loginUsername, isRoleViewOnly],
  );
}
